// These constants encapsulate the various categories of logins. The
// sheetz client is special because there are two backend endpoints
// ("sheetz" and "sheetz1"). Historically all sheetz users could switch
// between both backends; new requirements allow us to limit a particular
// username to only one of them.
const SHEETZ_CLIENTS = ['sheetz', 'sheetz1'];

// Put any usernames here that should not see the secondary sheetz1
// endpoint. This Cognito pool is case-insensitive, so usernames are
// normalized to lowercase before comparison.
const RESTRICTED_SHEETZ_USERS = [
  'mwilliams', // only access to "sheetz", not "sheetz1"
  'wrabold',
  'rnassar',
];

const LOGINS = {
  CLIENTS: {
    rutters: [
      'rob.malkus@rutters.com',
      'adam.hirt@rutters.com',
      'brandon.langeheine@rutters.com',
      'nathanial.littles@rutters.com',
      'gregg.miller@rutters.com',
      'joseph.strittmatter@rutters.com',
      'rutters-support',
    ],
    ta: ['eric.doornbos@ab-net.us'],
    sheetz: ['sheetz-support', 'sheetz-storesolutions', 'mwilliams', 'wrabold', 'rnassar'],
  },
  USERS: [
    'cubbys-support',
    'englefield-support',
    'friendship-support',
    'weigels-support',
    'daksmarket',
    'commoncents',
    'gitngo',
    'loopmarkets',
    'triplett',
    'jacobandco',
  ],
};

function findUserLogin(username) {
  const normalizedUsername = (username || '').toLowerCase();

  // Check USERS first since it's the simplest category.
  if (LOGINS.USERS.includes(normalizedUsername)) {
    // Extract the sub-client name by splitting on '-support'. This is
    // primarily used to filter the device list later on.
    const subClient = normalizedUsername.split('-support')[0];
    return { category: 'USERS', client: 'open', subClient: subClient };
  }

  // Otherwise look under CLIENTS. The keys in LOGINS.CLIENTS are the
  // canonical client names used throughout the app.
  for (const client in LOGINS.CLIENTS) {
    if (LOGINS.CLIENTS[client].includes(normalizedUsername)) {
      const result = { category: 'CLIENTS', client: client };

      // Special-case sheetz users: some users should only ever see the
      // "sheetz" backend and not the sister "sheetz1" service. Other
      // sheetz accounts are allowed to flip between both endpoints.
      if (client === 'sheetz') {
        if (RESTRICTED_SHEETZ_USERS.includes(normalizedUsername)) {
          result.allowedClients = ['sheetz'];
        } else {
          result.allowedClients = [...SHEETZ_CLIENTS];
        }
      }

      return result;
    }
  }

  // Username not recognised.
  return false;
}

const config = {
  OFFLINE_TIMEOUT: 30 * 60 * 1000, // 30 minutes
  WARNING_TIMEOUT: 15 * 60 * 1000, // 15 minutes
  SCREENSHOT_INTERVAL: 5 * 60 * 1000, // 5 minutes

  findUserLogin,
};

export default config;
